import { BROCHURE } from "../data/content";
import { isMediaPreview } from "./MediaSlot";

// Corporate brochure download slot. Public mode: renders only when a final
// approved PDF is configured (status "published" + pdfUrl). Owner preview
// (?media-preview=1 on non-production hosts) shows a labelled placement.
export const BrochureLink = ({ dark = false, className = "" }) => {
  if (BROCHURE.status === "published" && BROCHURE.pdfUrl) {
    return (
      <a
        href={BROCHURE.pdfUrl}
        data-testid="brochure-download"
        className={`text-xs font-semibold tracking-[0.2em] uppercase transition-colors duration-300 ${
          dark ? "text-ivory/40 hover:text-goldlight" : "text-charcoal/60 hover:text-golddark"
        } ${className}`}
      >
        Download our brochure{BROCHURE.meta ? ` (${BROCHURE.meta})` : ""}
      </a>
    );
  }
  if (isMediaPreview()) {
    return (
      <span
        data-testid="brochure-download"
        data-preview-frame="true"
        role="note"
        className={`text-xs tracking-[0.14em] uppercase ${dark ? "text-ivory/40" : "text-charcoal/50"} ${className}`}
      >
        Brochure placement — corporate brochure
      </span>
    );
  }
  return null;
};
